import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

export const useCurrentUserId = () => {
  return useSelector(Global.selectUserCurrentUserId);
};
